document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('variant:change', function (event) {
    const variant = event.detail.variant; // Assuming the variant object is passed in the event's detail
    if (variant) {
      const preOrderElement = document.querySelector('[data-pre-order]');
      const customForm = document.querySelector('form.custom-form');
      if (variant.available) {
        if (preOrderElement) {
          preOrderElement.style.display = 'block'; // Show the element
          (customForm) ? customForm.classList.remove("sold") : null;
        }
      } else {
        if (preOrderElement) {
          preOrderElement.style.display = 'none'; // Hide the element
          (customForm) ? customForm.classList.add("sold") : null;
        }
      }
    }
  });
  
  function swapImageSources() {
      const mobileWidth = 768; // Screen width threshold for mobile devices
      const images = document.querySelectorAll('[data-mobile-source][data-desktop-source]');
    
      images.forEach(function (image) {
        const mobileSource = image.getAttribute('data-mobile-source');
        const desktopSource = image.getAttribute('data-desktop-source');
        
        // Check if the mobile source exists and is valid
        if (window.innerWidth < mobileWidth && mobileSource) {
          if (image.src !== mobileSource) {
            image.src = mobileSource; // Use mobile image if available
          }
        } else {
          // If no mobile source, or screen is not mobile, use the desktop image
          if (image.src !== desktopSource) {
            image.src = desktopSource; // Use desktop image (default)
          }
        }
      });
    }

    swapImageSources();
    
    // Add event listener to swap images when the screen is resized
    let resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(swapImageSources, 200); // Throttle resize event for performance
    });

});
